import { Theme, createAppTheme } from '@prometheus/components';

export let theme: Theme = createAppTheme();
